import React, { useState, useEffect, useCallback } from "react";
import { supabase } from "../../supabaseClient";
import LoaderBox from "../HomePage/LoaderBox";

const AdminRaspored = () => {
  const dani = [
    "Utakmice",
    "Uto 23.6.",
    "Sri 24.6.",
    "Čet 25.6.",
    "Pet 26.6.",
    "Sub 27.6.",
  ];
  const [activeDan, setActiveDan] = useState("Utakmice");
  const [teams, setTeams] = useState([]);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isScheduleVisible, setIsScheduleVisible] = useState(false);
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  // Funkcija za direktnu promjenu i spremanje u bazu
  const handleToggleSchedule = async (newValue) => {
    setIsScheduleVisible(newValue);
    await supabase
      .from("site_settings")
      .update({ prikazi_raspored: newValue })
      .eq("id", 1);
  };

  // Generiranje satnica svakih 30 minuta
  // Generiranje satnica svakih 5 minuta
  const satnice = [];
  for (let h = 9; h <= 23; h++) {
    for (let m = 0; m < 60; m += 5) {
      const minutesFormatted = String(m).padStart(2, "0");
      satnice.push(`${h}:${minutesFormatted}`);
    }
  }
  satnice.push("00:00");

  const loadData = useCallback(async () => {
    setLoading(true);
    const { data: settingData } = await supabase
      .from("site_settings")
      .select("prikazi_raspored")
      .eq("id", 1)
      .single();

    if (settingData) {
      setIsScheduleVisible(settingData.prikazi_raspored);
    }
    // 1. Dohvati sve timove (da imamo imena za prikaz)
    const { data: teamsData } = await supabase.from("teams").select("*");
    setTeams(teamsData || []);

    // 2. Dohvati SVE utakmice (i grupne i nokaut fazu)
    const { data: existingMatches } = await supabase
      .from("matches")
      .select("*");

    let finalMatchesList = [];

    // Dodaj sve što već postoji u bazi (ovo uključuje "Završnicu" iz AdminChampionship)
    if (existingMatches) {
      finalMatchesList = [...existingMatches];
    }

    // 3. Generiraj parove za grupe koji još NE postoje u bazi (automatika za grupnu fazu)
    const groups = ["A", "B", "C", "D", "E", "F", "G", "H"];
    groups.forEach((gr) => {
      const teamsInGroup = (teamsData || []).filter((t) => t.group_name === gr);
      for (let i = 0; i < teamsInGroup.length; i++) {
        for (let j = i + 1; j < teamsInGroup.length; j++) {
          const tA = teamsInGroup[i];
          const tB = teamsInGroup[j];

          const exists = finalMatchesList.find(
            (m) =>
              (m.team_a_id === tA.id && m.team_b_id === tB.id) ||
              (m.team_a_id === tB.id && m.team_b_id === tA.id),
          );

          if (!exists) {
            finalMatchesList.push({
              group_name: gr,
              team_a_id: tA.id,
              team_b_id: tB.id,
              match_day: "",
              match_time: "",
            });
          }
        }
      }
    });

    setMatches(finalMatchesList);
    setLoading(false);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const updateMatchInDb = async (match, field, value) => {
    const dbField = field === "dan" ? "match_day" : "match_time";
    const updateData = { [dbField]: value };

    // Lokalni update za instantan UI
    setMatches((prev) =>
      prev.map((m) => {
        const isSameMatch = m.id
          ? m.id === match.id
          : m.team_a_id === match.team_a_id && m.team_b_id === match.team_b_id;

        return isSameMatch ? { ...m, [dbField]: value } : m;
      }),
    );

    if (match.id) {
      // Postojeća utakmica (bilo grupna ili završnica)
      await supabase.from("matches").update(updateData).eq("id", match.id);
    } else {
      // Nova grupna utakmica koja se prvi put sprema
      const { data } = await supabase
        .from("matches")
        .insert([
          {
            team_a_id: match.team_a_id,
            team_b_id: match.team_b_id,
            group_name: match.group_name,
            match_day: field === "dan" ? value : "",
            match_time: field === "vrijeme" ? value : "",
            is_completed: false,
            scorea: 0,
            scoreb: 0,
          },
        ])
        .select();

      if (data) loadData();
    }
  };

  // Logika filtriranja: Tab "Utakmice" pokazuje one bez termina
  let displayedMatches = [];
  if (activeDan === "Utakmice") {
    // Prikazujemo samo utakmice koje NISU završene i nemaju termin
    displayedMatches = matches.filter(
      (m) => !m.is_completed && (!m.match_day || !m.match_time),
    );
  } else {
    displayedMatches = matches
      .filter((m) => m.match_day === activeDan && m.match_time)
      .sort((a, b) => a.match_time.localeCompare(b.match_time));
  }

  if (loading) return <LoaderBox text="Učitavanje rasporeda..." />;

  return (
    <div className="admin-raspored">
      <div className="visibility-control-bar">
        <span className="control-label">
          Prikaži raspored na webu
          {isLocalhost && <small className="localhost-badge"> </small>}
        </span>

        <label className="ios-switch">
          <input
            type="checkbox"
            checked={isScheduleVisible}
            onChange={(e) => handleToggleSchedule(e.target.checked)}
          />
          <span className="slider"></span>
        </label>
      </div>
      <div className="day-navigation">
        {dani.map((d) => (
          <button
            key={d}
            className={`${activeDan === d ? "active" : ""} ${d === "Utakmice" ? "unassigned-tab" : ""}`}
            onClick={() => setActiveDan(d)}
          >
            {d}
          </button>
        ))}
      </div>

      <div className="raspored-content">
        <section className="assigned-section">
          <h4>
            {activeDan === "Utakmice"
              ? "Utakmice na čekanju"
              : `Raspored za dan: ${activeDan}`}
          </h4>
          <div className="matches-list">
            {displayedMatches.length > 0 ? (
              displayedMatches.map((m) => (
                <MatchRow
                  key={m.id || `temp-${m.team_a_id}-${m.team_b_id}`}
                  match={m}
                  satnice={satnice}
                  dani={dani.filter((d) => d !== "Utakmice")}
                  update={updateMatchInDb}
                  teams={teams}
                  allMatches={matches}
                />
              ))
            ) : (
              <p className="empty-info">Nema utakmica u ovoj kategoriji.</p>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

// POMOĆNA KOMPONENTA ZA REDAK UTAKMICE
const MatchRow = ({ match, satnice, dani, update, teams, allMatches }) => {
  const tA = teams.find((t) => t.id === match.team_a_id)?.name || "???";
  const tB = teams.find((t) => t.id === match.team_b_id)?.name || "???";

  // Pretvaranje slot_id u kratku oznaku
  const getFazaLabel = () => {
    if (!match.bracket_slot_id) return match.group_name; // Vraća A, B, C...

    const id = match.bracket_slot_id;
    if (id >= 1 && id <= 8) return "1/8";
    if (id >= 9 && id <= 12) return "1/4";
    if (id >= 13 && id <= 14) return "1/2";
    if (id === 15) return "F";
    if (id === 16) return "3.mj";
    return "Z";
  };

  const isTimeTaken = (vrijeme) => {
    if (!match.match_day) return false;
    return allMatches.some(
      (m) =>
        m.match_day === match.match_day &&
        m.match_time === vrijeme &&
        m.id !== match.id,
    );
  };

  return (
    <div
      className={`admin-match-row ${match.is_completed ? "completed-match-row" : ""}`}
    >
      <div
        className={`group-tag ${match.bracket_slot_id ? "knockout-tag" : ""}`}
      >
        {getFazaLabel()}
      </div>

      <div className="teams-info">
        <div className="team-line">
          <span className="team-name">{tA}</span>
          {match.is_completed && (
            <span className="match-score">{match.scorea}</span>
          )}
        </div>
        <div className="team-line">
          <span className="team-name">{tB}</span>
          {match.is_completed && (
            <span className="match-score">{match.scoreb}</span>
          )}
        </div>
      </div>

      <div className="selectors">
        {match.is_completed ? (
          <div className="completed-info" style={{ textAlign: "center" }}>
            <div className="completed-badge">ODIGRANO</div>
            <span
              className="played-time-label"
              style={{
                fontSize: "12px",
                display: "block",
                marginTop: "4px",
                color: "#9b9999ff",
                fontWeight: "600",
              }}
            >
              {match.match_time}
            </span>
          </div>
        ) : (
          <>
            <select
              value={match.match_day || ""}
              onChange={(e) => update(match, "dan", e.target.value)}
            >
              <option value="">Odaberi Dan</option>
              {dani.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}
            </select>

            <select
              value={match.match_time || ""}
              onChange={(e) => update(match, "vrijeme", e.target.value)}
              disabled={!match.match_day}
            >
              <option value="">Odaberi vrijeme</option>
              {satnice.map((s) => (
                <option key={s} value={s} disabled={isTimeTaken(s)}>
                  {s}
                </option>
              ))}
            </select>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminRaspored;
